import {useDispatch} from "react-redux";
import {AppDispatch} from "./storeIndex";

export const useAppThunkDispatch = () => useDispatch<AppDispatch>();